/* eslint-disable no-unused-vars, eqeqeq */
import { useState, useEffect, Fragment, useRef, useCallback } from "react";
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import IconButton from "@mui/material/IconButton";
import MuiInput from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { styled } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup, {
  toggleButtonGroupClasses,
} from "@mui/material/ToggleButtonGroup";
import useMediaQuery from "@mui/material/useMediaQuery";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import EditIcon from "@mui/icons-material/Edit";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import Dropdown from "@mui/joy/Dropdown";
import MenuButton from "@mui/joy/MenuButton";
import MoreVert from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import SaveIcon from "@mui/icons-material/Save";
import LinearProgress from "@mui/material/LinearProgress";
import RefreshIcon from "@mui/icons-material/Refresh";
import SpdGraph from "./SpdGraph";
import RoutineScheduleChart from "./RoutineScheduleChart";
import { sortRoutinesByActionTimeAsc } from "../../utils/sortRoutinesByActionTime";
import { isSensorTelemetryStale } from "../../utils/sensorTelemetryFreshness";
import {
  setAlertFlag,
  getAlertFlag,
  setSpectrumData,
} from "../global/globalVariables";

// import jwt from "jsonwebtoken";
import { jwtDecode } from "jwt-decode";

import {
  getRooms,
  getSpectrum,
  updateSpectrum,
  getAllSpectrum,
  getSpectrumByRoomId,
  createRoutine,
  createSpectrum,
  updateSpectrumRoom,
  updateSpectrumRoomData,
  getAllSpectrumByRoomId,
  changeSpectrum,
  getRoutinesByRoomId,
  getDevices,
  getDataLogs,
} from "../service/service_handler";

const Input = styled(MuiInput)`
  width: 42px;
`;

// const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
//   "& .MuiToggleButtonGroup-grouped": {
//     margin: theme.spacing(0.5),
//     border: 2,
//     "&.Mui-disabled": {
//       border: 2,
//       color: "primary",
//       background: "black",
//     },
//     "&:not(:first-of-type)": {
//       borderRadius: theme.shape.borderRadius,
//       background: "black",
//     },
//     "&:first-of-type": {
//       borderRadius: theme.shape.borderRadius,
//       background: "black",
//     },
//   },
//   background: "primry",
// }));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.7),
    border: 1,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 1,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      marginLeft: 1,
      borderLeft: "2px solid transparent",
    },
}));

const spectrum_controls = [
  {
    channelName: "Green",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Red",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Yellow",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Blue",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Pink",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Orange",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Channel",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Dummy 1",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Dummy 2",
    channelValue: 10,
    isActive: true,
  },
];

const channelOptions = [
  { name: "3000K WHITE", color: "#FACC15" },
  { name: "4000K WHITE", color: "#FACC15" },
  { name: "5700K WHITE", color: "#FACC15" },
  { name: "6500K WHITE", color: "#FACC15" },
  { name: "395NM UV", color: "#8B5CF6" },
  { name: "450NM BLUE", color: "#3B82F6" },
  { name: "520NM GREEN", color: "#22C55E" },
  { name: "630NM RED", color: "#EF4444" },
  { name: "660NM DEEP RED", color: "#EF4444" },
  { name: "735NM HYPER RED", color: "#EC4899" },
];

const channelColorMap = channelOptions.reduce((acc, option) => {
  acc[option.name] = option.color;
  return acc;
}, {});

// const roles = [
//   "add-device",
//   "add-user",
//   "add-spectrum",
//   "edit-spectrum",
//   "add-routines",
//   "edit-routines",
// ];
// const roles = jwt.decode(localStorage.getItem("token"));

// localStorage.getItem("token") == ""
//     ? const roles = jwtDecode()
//     : (window.location.href = "/app-login")

// console.log("Roles: " + JSON.stringify(roles));

export default function HomeScreen() {
  const [open, setOpen] = useState(false);
  const [weekNames, setWeekNames] = useState("");
  const [activeRoom, setActiveRoom] = useState({});
  const [roomNames, setRoomNames] = useState([]);
  const [roomName, setRoomName] = useState("");
  const [roomDetails, setRoomDetails] = useState({});
  const [weeks, setWeeks] = useState(() => []);
  const [value, setValue] = useState([]);
  const [spectrum, setSpectrum] = useState(() => []);
  const [openSnack, setOpenSnack] = useState(false);
  const [openSnackErrMsg, setopenSnackErrMsg] = useState("");
  const [exisingSchedule, setExisingSchedule] = useState("");
  const [checked, setChecked] = useState(true);
  // const weeksName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const [isVisible, setIsVisible] = useState(false);
  const [lockRatio, setLockRatio] = useState(false);
  const [openSpectrum, setOpenSpectrum] = useState(false);
  const [routineNameInput, setRoutineNameInput] = useState("");
  const [routineAction, setRoutineAction] = useState("ON");
  const [routineTime, setRoutineTime] = useState(dayjs(new Date().getTime()));
  const [noRoomData, setNoRoomData] = useState(false);
  const [noSpectrumData, setNoSpectrumData] = useState(false);
  const [spectrumName, setSpectrumName] = useState("");
  const [spectrumNames, setSpectrumNames] = useState([]);
  const [spectrumNameAct, setSpectrumNameAct] = useState({});
  const [openEditName, setOpenEditName] = useState(false);
  const [editedChannelName, setEditedChannelName] = useState("");
  const [noData, setNoData] = useState(false);
  const [roles, setRoles] = useState([]);
  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const [weekValues, setWeekValues] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [spectrumNameRot, setSpectrumNameRot] = useState("");
  const [spectrumNamesRot, setSpectrumNamesRot] = useState([]);
  const [roomNameRot, setRoomNameRot] = useState("");
  const [spectrumNameText, setSpectrumNameText] = useState("");
  const [lableData, setLableData] = useState({});
  const [spectrumSaveDisabled, setSpectrumSaveDisabled] = useState(true);
  const [masterSpectrumIndex, setMasterSpectrumIndex] = useState(-1);
  const [cachedRoom, setCachedRoom] = useState(0);
  const [routines, setRoutines] = useState([]);
  const [routineSpectrums, setRoutineSpectrums] = useState({});
  const [routineChartLoading, setRoutineChartLoading] = useState(false);
  const [routineChartError, setRoutineChartError] = useState("");
  const [sensorDevices, setSensorDevices] = useState([]);
  const [sensorDevicesLoaded, setSensorDevicesLoaded] = useState(false);
  const [selectedSensorDevice, setSelectedSensorDevice] = useState("Average");
  const [selectedLuxDevice, setSelectedLuxDevice] = useState("Average");
  const [selectedTempDevice, setSelectedTempDevice] = useState("Average");
  const [selectedHumidityDevice, setSelectedHumidityDevice] = useState("Average");
  const [lastDaySensorLogs, setLastDaySensorLogs] = useState([]);
  const ratioCacheRef = useRef([]);
  let timeoutId1;
  let timeoutId2;
  // const [name, setName] = useState<string|undefined>(localStorage.getItem("name") || undefined)
  var localizedFormat = require("dayjs/plugin/localizedFormat");
  const isMobile = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    if (localStorage.getItem("token")) {
      setRoles(jwtDecode(localStorage.getItem("token")).roles);
      console.log(
        "roles: " + JSON.stringify(jwtDecode(localStorage.getItem("token")))
      );
    }
    let spectrumId;
    getRooms()
      .then(function (response) {
        // const act_room = localStorage.getItem("act_room");
        const cached_room_id = localStorage.getItem("cached_room");
        console.log("cached-room: " + cached_room_id);

        setRoomNames(response.data.rooms);
        let foundIndex = response.data.rooms.findIndex(
          (item) => item.roomId == cached_room_id
        );
        console.log("foundIndex: " + foundIndex);
        if (foundIndex !== -1) {
          console.log("room found - " + foundIndex);
          setActiveRoom(response.data.rooms[foundIndex]);
        } else {
          setActiveRoom(response.data.rooms[0]);
          foundIndex = 0;
          console.log("room not found");
        }

        if (response.data.rooms.length > 0) {
          const selectedRoom = response.data.rooms[foundIndex];
          spectrumId = selectedRoom.spectrumControlId;
          loadRoutinesForRoom(selectedRoom.roomId);
          getSpectrum(selectedRoom.spectrumControlId)
            .then(function (response) {
              if (response.data.spectrum.orgCode == "SUPER_ADMIN") {
                setSpectrumSaveDisabled(true);
              }
              setSpectrum(response.data.spectrum.channelData);
              ratioCacheRef.current = [];
              setLockRatio(response.data.spectrum.lockRatio);
              // const max_index = response.data.spectrum.channelData.indexOf(
              //   Math.max(...response.data.spectrum.channelData)
              // );
              if (response.data.spectrum.lockRatio != 0) {
                // const max_index = response.data.spectrum.channelData.indexOf(
                //   response.data.spectrum.channelData.reduce(function (
                //     prev,
                //     current
                //   ) {
                //     return prev && prev.channelValue > current.channelValue
                //       ? prev
                //       : current;
                //   })
                // );

                let max_index = -1;
                let max = -Infinity;
                response.data.spectrum.channelData.forEach((obj, index) => {
                  if (obj.isActive && obj.channelValue > max) {
                    max = obj.channelValue;
                    max_index = index;
                  }
                });
                if (max_index == -1) {
                  max_index = 0;
                }
                console.log("max val: " + max_index);
                setMasterSpectrumIndex(max_index);
              }
              // delete response.data.spectrum[0].channelData;
              // console.log(
              //   "ACT spectrum: " + JSON.stringify(response.data.spectrum)
              // );
              // setSpectrumNameAct(response.data.spectrum[0]);
            })
            .catch((error) => {
              console.log("service-error", error);
              if (!error.response) {
                setopenSnackErrMsg("Network error please try again");
                setOpenSnack(true);
                setNoData(true);
              } else {
                setopenSnackErrMsg(
                  error.response.data.code + " - Please try again later"
                );
                setOpenSnack(true);
                setNoData(true);
              }
            });

          getAllSpectrum()
            .then(function (response) {
              console.log(
                "ACT spectrum1: " + JSON.stringify(response.data.spectrums[0])
              );
              const allSpectrums = response.data.spectrums || [];
              setSpectrumNames(allSpectrums);
              if (!allSpectrums.length) {
                setSpectrumNameAct({});
                return;
              }
              const matched =
                spectrumId &&
                allSpectrums.find(
                  ({ spectrumControlId }) => spectrumControlId === spectrumId
                );
              setSpectrumNameAct(matched || allSpectrums[0]);
            })
            .catch((error) => {
              console.log("service-error", error);
              if (!error.response) {
                setopenSnackErrMsg("Network error please try again");
                setOpenSnack(true);
                setNoData(true);
              } else {
                setopenSnackErrMsg(
                  error.response.data.code + " - Please try again later"
                );
                setOpenSnack(true);
                setNoData(true);
              }
            });
        }
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
        }
      });

    getDevices()
      .then(function (response) {
        const sensors =
          response.data.devices?.filter(
            (device) => (device.deviceType || "").toLowerCase() === "sensor"
          ) || [];
        setSensorDevices(sensors);
        setSensorDevicesLoaded(true);
      })
      .catch((error) => {
        console.log("service-error", error);
        setSensorDevicesLoaded(true);
      });

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      console.log("Component detached");
    };
  }, []);

  useEffect(() => {
    const fetchDevices = () => {
      getDevices()
        .then(function (response) {
          const sensors =
            response.data.devices?.filter(
              (device) => (device.deviceType || "").toLowerCase() === "sensor"
            ) || [];
          setSensorDevices(sensors);
          setSensorDevicesLoaded(true);
        })
        .catch((error) => {
          console.log("service-error", error);
          setSensorDevicesLoaded(true);
        });
    };

    fetchDevices();
    const intervalId = setInterval(fetchDevices, 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!routines.length) {
      return;
    }
    const uniqueSpectrumIds = Array.from(
      new Set(
        routines
          .map((routine) => routine?.spectrumId)
          .filter((spectrumId) => spectrumId !== undefined && spectrumId !== null)
      )
    );
    if (!uniqueSpectrumIds.length) {
      return;
    }
    uniqueSpectrumIds.forEach((spectrumId) => {
      if (routineSpectrums[spectrumId]) {
        return;
      }
      getSpectrum(spectrumId)
        .then((response) => {
          setRoutineSpectrums((prev) => ({
            ...prev,
            [spectrumId]: response.data.spectrum,
          }));
        })
        .catch(() => {
          setRoutineChartError("Unable to load routine spectrum details");
        });
    });
  }, [routines, routineSpectrums]);

  useEffect(() => {
    if (!Array.isArray(spectrum) || spectrum.length === 0) {
      return;
    }

    const spectrumName = (spectrumNameAct?.spectrumName || "").toLowerCase();
    if (spectrumName === "spectrum off") {
      return;
    }

    const hasActive = spectrum.some((value) => value.isActive);
    if (!hasActive) {
      setSpectrum((prevValues) => {
        const newValues = [...prevValues];
        newValues[0].isActive = true;
        if (newValues[0].channelValue === 0) {
          newValues[0].channelValue = 1;
        }
        return newValues;
      });
    }
  }, [spectrum, spectrumNameAct]);

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "Ok";
    return "Are you sure you want to leave?";
  };

  const getRoomScopedSelectionKey = useCallback(
    (selectionType, roomId) => `room_${roomId}_${selectionType}`,
    []
  );

  const getStoredRoomSelection = useCallback(
    (selectionType, roomId) => {
      if (!roomId) return "Average";
      return (
        localStorage.getItem(getRoomScopedSelectionKey(selectionType, roomId)) ||
        "Average"
      );
    },
    [getRoomScopedSelectionKey]
  );

  const handleSensorDeviceChange = (event) => {
    const nextValue = event.target.value;
    setSelectedSensorDevice(nextValue);
    if (activeRoom?.roomId) {
      localStorage.setItem(
        getRoomScopedSelectionKey("sensorDeviceSelection", activeRoom.roomId),
        nextValue
      );
    }
  };
  const handleLuxDeviceChange = (event) => {
    const nextValue = event.target.value;
    setSelectedLuxDevice(nextValue);
    if (activeRoom?.roomId) {
      localStorage.setItem(
        getRoomScopedSelectionKey("luxDeviceSelection", activeRoom.roomId),
        nextValue
      );
    }
  };
  const handleTempDeviceChange = (event) => {
    const nextValue = event.target.value;
    setSelectedTempDevice(nextValue);
    if (activeRoom?.roomId) {
      localStorage.setItem(
        getRoomScopedSelectionKey("roomTempDeviceSelection", activeRoom.roomId),
        nextValue
      );
    }
  };
  const handleHumidityDeviceChange = (event) => {
    const nextValue = event.target.value;
    setSelectedHumidityDevice(nextValue);
    if (activeRoom?.roomId) {
      localStorage.setItem(
        getRoomScopedSelectionKey(
          "roomHumidityDeviceSelection",
          activeRoom.roomId
        ),
        nextValue
      );
    }
  };

  const activeRoomSensorDevices = sensorDevices.filter((device) => {
    if (!activeRoom?.roomId) return false;
    const deviceRoomId = device?.roomId ?? device?.room?.roomId ?? device?.Room?.roomId;
    return String(deviceRoomId) === String(activeRoom.roomId);
  });

  useEffect(() => {
    if (!activeRoom?.roomId) {
      return;
    }

    setSelectedSensorDevice(
      getStoredRoomSelection("sensorDeviceSelection", activeRoom.roomId)
    );
    setSelectedLuxDevice(
      getStoredRoomSelection("luxDeviceSelection", activeRoom.roomId)
    );
    setSelectedTempDevice(
      getStoredRoomSelection("roomTempDeviceSelection", activeRoom.roomId)
    );
    setSelectedHumidityDevice(
      getStoredRoomSelection("roomHumidityDeviceSelection", activeRoom.roomId)
    );
  }, [activeRoom?.roomId, getStoredRoomSelection]);

  useEffect(() => {
    if (!sensorDevicesLoaded) {
      return;
    }

    const availableDeviceIds = new Set(
      activeRoomSensorDevices.map((device) => device.deviceSerialNo)
    );

    if (
      selectedSensorDevice !== "Average" &&
      !availableDeviceIds.has(selectedSensorDevice)
    ) {
      setSelectedSensorDevice("Average");
      if (activeRoom?.roomId) {
        localStorage.setItem(
          getRoomScopedSelectionKey(
            "sensorDeviceSelection",
            activeRoom.roomId
          ),
          "Average"
        );
      }
    }

    if (
      selectedTempDevice !== "Average" &&
      !availableDeviceIds.has(selectedTempDevice)
    ) {
      setSelectedTempDevice("Average");
      if (activeRoom?.roomId) {
        localStorage.setItem(
          getRoomScopedSelectionKey(
            "roomTempDeviceSelection",
            activeRoom.roomId
          ),
          "Average"
        );
      }
    }

    if (
      selectedHumidityDevice !== "Average" &&
      !availableDeviceIds.has(selectedHumidityDevice)
    ) {
      setSelectedHumidityDevice("Average");
      if (activeRoom?.roomId) {
        localStorage.setItem(
          getRoomScopedSelectionKey(
            "roomHumidityDeviceSelection",
            activeRoom.roomId
          ),
          "Average"
        );
      }
    }

    if (
      selectedLuxDevice !== "Average" &&
      !availableDeviceIds.has(selectedLuxDevice)
    ) {
      setSelectedLuxDevice("Average");
      if (activeRoom?.roomId) {
        localStorage.setItem(
          getRoomScopedSelectionKey("luxDeviceSelection", activeRoom.roomId),
          "Average"
        );
      }
    }
  }, [
    activeRoom?.roomId,
    activeRoomSensorDevices,
    sensorDevicesLoaded,
    selectedHumidityDevice,
    selectedLuxDevice,
    selectedSensorDevice,
    selectedTempDevice,
  ]);

  const parseMetricValue = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  };

  const formatMetricValue = (value) => {
    if (value == null) return "NA";
    const rounded = Math.round(value * 100) / 100;
    return Number.isInteger(rounded) ? rounded : rounded.toFixed(2);
  };

  const formatOneDecimalValue = (value) => {
    if (value == null) return "NA";
    const n = Number(value);
    if (!Number.isFinite(n)) return "NA";
    return n.toFixed(1);
  };

  const formatIntegerValue = (value) => {
    if (value == null) return "NA";
    const n = Number(value);
    if (!Number.isFinite(n)) return "NA";
    return String(Math.round(n));
  };

  const getAverageValueForKey = (key) => {
    const onlineSensors = activeRoomSensorDevices.filter(
      (d) => !isSensorTelemetryStale(d)
    );
    const values = onlineSensors
      .map((device) => parseMetricValue(device[key]))
      .filter((value) => {
        if (value == null || !Number.isFinite(value)) return false;
        if (key === "ppfd" || key === "lux") return value >= 0;
        return value > 0;
      });
    if (!values.length) return null;
    return values.reduce((total, value) => total + value, 0) / values.length;
  };

  const getSelectedValueForKey = (selectedDeviceId, key) => {
    if (selectedDeviceId === "Average") {
      return getAverageValueForKey(key);
    }
    const selected = activeRoomSensorDevices.find(
      (device) => device.deviceSerialNo === selectedDeviceId
    );
    if (!selected) return null;
    if (isSensorTelemetryStale(selected)) return null;
    const value = parseMetricValue(selected[key]);
    if (value == null || !Number.isFinite(value)) return null;
    if (key === "ppfd" || key === "lux") return value >= 0 ? value : null;
    return value > 0 ? value : null;
  };

  const getYesterdayDateString = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  useEffect(() => {
    if (!activeRoom?.roomId) {
      setLastDaySensorLogs([]);
      return;
    }

    const fetchLogs = () => {
      const yDate = getYesterdayDateString();
      getDataLogs({
        roomId: activeRoom.roomId,
        fromDate: yDate,
        toDate: yDate,
      })
        .then((response) => {
          setLastDaySensorLogs(response.data.logs || []);
        })
        .catch(() => {
          setLastDaySensorLogs([]);
        });
    };

    fetchLogs();
    const intervalId = setInterval(fetchLogs, 60 * 1000);
    return () => clearInterval(intervalId);
  }, [activeRoom?.roomId]);

  const getSelectedLastDayField = (fieldName) => {
    if (!Array.isArray(lastDaySensorLogs) || lastDaySensorLogs.length === 0) {
      return null;
    }
    if (selectedSensorDevice === "Average") {
      const roomSensorDeviceIds = new Set(
        activeRoomSensorDevices.map((d) => Number(d.deviceId)).filter(Boolean)
      );
      const values = lastDaySensorLogs
        .filter((row) => roomSensorDeviceIds.has(Number(row.deviceId)))
        .map((row) => Number(row[fieldName]))
        .filter((v) => Number.isFinite(v));
      if (!values.length) return null;
      return values.reduce((sum, v) => sum + v, 0) / values.length;
    }
    const selectedSensor = activeRoomSensorDevices.find(
      (device) => device.deviceSerialNo === selectedSensorDevice
    );
    if (!selectedSensor) return null;
    const logRow = lastDaySensorLogs.find(
      (row) => Number(row.deviceId) === Number(selectedSensor.deviceId)
    );
    if (!logRow) return null;
    const n = Number(logRow[fieldName]);
    return Number.isFinite(n) ? n : null;
  };

  const isRoutineActiveToday = (routine) => {
    if (!routine) {
      return false;
    }
    const daysString = routine.daysInWeek;
    if (daysString == null || daysString === "") {
      return false;
    }
    const parts = String(daysString)
      .split(",")
      .map((value) => Number(value));
    const todayIndex = new Date().getDay(); // 0 (Sun) - 6 (Sat)
    if (todayIndex < 0 || todayIndex >= parts.length) {
      return false;
    }
    return Number(parts[todayIndex]) === 1;
  };

  const parseRoutineTime = (actionTime) => {
    if (actionTime == null) {
      return null;
    }
    if (typeof actionTime === "number" && Number.isFinite(actionTime)) {
      const date = new Date(actionTime * 1000);
      return (
        date.getHours() + date.getMinutes() / 60 + date.getSeconds() / 3600
      );
    }
    if (typeof actionTime === "string") {
      const trimmed = actionTime.trim();
      if (!trimmed) {
        return null;
      }
      if (/^\d+(\.\d+)?$/.test(trimmed)) {
        const numeric = Number(trimmed);
        if (Number.isFinite(numeric)) {
          const date = new Date(numeric * 1000);
          return (
            date.getHours() + date.getMinutes() / 60 + date.getSeconds() / 3600
          );
        }
      }
      if (trimmed.includes(":")) {
        const parts = trimmed.split(":").map((part) => Number(part));
        if (parts.length >= 2 && parts.every((value) => Number.isFinite(value))) {
          const [hours, minutes, seconds = 0] = parts;
          return hours + minutes / 60 + seconds / 3600;
        }
      }
    }
    return null;
  };

  const normalizeRoutineAction = (action) => {
    if (typeof action === "string") {
      const normalized = action.trim().toUpperCase();
      if (normalized === "ON") {
        return 1;
      }
      if (normalized === "OFF") {
        return 0;
      }
    }
    const numeric = Number(action);
    if (!Number.isFinite(numeric)) {
      return null;
    }
    if (numeric === 1) {
      return 1;
    }
    if (numeric === 0) {
      return 0;
    }
    return null;
  };

  /**
   * Photoperiod is measured in a 24h window that starts at the earliest ON time today
   * (not calendar midnight). Clock times before that ON roll to the next calendar day
   * so ON→OFF can span midnight (e.g. ON 22:00 → OFF 06:00 = 8h).
   * Total = sum of (next OFF − current ON) for every ON segment in chronological order
   * within that window; if lights stay ON with no further OFF, count until end of window.
   */
  const computePhotoperiodHours = (routineList) => {
    if (!Array.isArray(routineList) || routineList.length === 0) {
      return null;
    }

    const normalized = routineList
      .filter((routine) => routine && routine.status !== 0 && isRoutineActiveToday(routine))
      .map((routine) => {
        let time = parseRoutineTime(routine.actionTime);
        if (Number.isFinite(time) && time >= 24) {
          time = time % 24;
        }
        const action = normalizeRoutineAction(routine.action);
        return { time, action };
      })
      .filter(
        (item) =>
          Number.isFinite(item.time) &&
          item.time >= 0 &&
          item.time < 24 &&
          (item.action === 0 || item.action === 1)
      );

    if (normalized.length === 0) {
      return null;
    }

    const onEvents = normalized.filter((item) => item.action === 1);
    if (onEvents.length === 0) {
      return 0;
    }

    const anchor = Math.min(...onEvents.map((item) => item.time));

    const WINDOW = 24;
    const EPS = 1e-6;

    const withOffset = normalized
      .map((item) => {
        let offset = item.time - anchor;
        if (offset < 0) {
          offset += WINDOW;
        }
        return { action: item.action, offsetHours: offset };
      })
      .filter((item) => item.offsetHours < WINDOW - EPS)
      .sort((a, b) => a.offsetHours - b.offsetHours);

    let totalHours = 0;
    let currentOnStart = null;

    withOffset.forEach((item) => {
      if (item.action === 1) {
        if (currentOnStart == null) {
          currentOnStart = item.offsetHours;
        }
      } else if (currentOnStart != null) {
        totalHours += Math.max(0, item.offsetHours - currentOnStart);
        currentOnStart = null;
      }
    });

    if (currentOnStart != null) {
      totalHours += Math.max(0, WINDOW - currentOnStart);
    }

    return totalHours;
  };

  const updateSpectrumList = () => {
    getAllSpectrum()
      .then(function (response) {
        setSpectrumNames(response.data.spectrums);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });
  };

  const handleRoomChange = (e, val) => {
    console.log("rooms:" + JSON.stringify(roomNames));
    if (!val) {
      return;
    }

    getSpectrum(val.spectrumControlId)
      .then(function (response) {
        if (response.data.spectrum.orgCode == "SUPER_ADMIN") {
          setSpectrumSaveDisabled(true);
        }
        setSpectrum(response.data.spectrum.channelData);
        ratioCacheRef.current = [];
        setLockRatio(response.data.spectrum.lockRatio);

        if (response.data.spectrum.lockRatio != 0) {
          // const max_index = response.data.spectrum.channelData.indexOf(
          //   response.data.spectrum.channelData.reduce(function (prev, current) {
          //     return prev && prev.channelValue > current.channelValue
          //       ? prev
          //       : current;
          //   })
          // );
          let max_index = -1;
          let max = -Infinity;
          response.data.spectrum.channelData.forEach((obj, index) => {
            if (obj.isActive && obj.channelValue > max) {
              max = obj.channelValue;
              max_index = index;
            }
          });
          if (max_index == -1) {
            max_index = 0;
          }
          console.log("max val: " + max_index);
          setMasterSpectrumIndex(max_index);
        }

        delete response.data.spectrum.channelData;
        console.log("ACT spectrum: " + JSON.stringify(response.data.spectrum));
        // setSpectrumNameAct(response.da/ta.spectrum);
        setActiveRoom(val);
        localStorage.setItem("cached_room", val.roomId);
        loadRoutinesForRoom(val.roomId);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("No Data found");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });

    getAllSpectrum()
      .then(function (response) {
        response.data.spectrums.forEach((element) => {
          if (element.spectrumControlId == val.spectrumControlId) {
            console.log("ACT-spect: " + JSON.stringify(element));
            setSpectrumNameAct(element);
          }
        });
        setSpectrumNames(response.data.spectrums);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });

    // getRooms()
    //   .then(function (response) {
    //     console.log("room: " + JSON.stringify(response.data.rooms));

    //     const cached_room_id = localStorage.getItem("cached_room");
    //     console.log("cached-room: " + cached_room_id);

    //     setRoomNames(response.data.rooms);
    //     let foundIndex = response.data.rooms.findIndex(
    //       (item) => item.roomId == cached_room_id
    //     );
    //     console.log("foundIndex: " + foundIndex);
    //     if (foundIndex !== -1) {
    //       console.log("room found - " + foundIndex);
    //       setActiveRoom(response.data.rooms[foundIndex]);
    //     } else {
    //       setActiveRoom(response.data.rooms[0]);
    //       foundIndex = 0;
    //       console.log("room not found");
    //     }
    //     // setRoomNames(response.data.rooms);
    //   })
    //   .catch((error) => {
    //     console.log("service-error", error);
    //     if (!error.response) {
    //       setopenSnackErrMsg("No Data found");
    //       setOpenSnack(true);
    //       setNoData(true);
    //     } else {
    //       setopenSnackErrMsg(
    //         error.response.data.code + " - Please try again later"
    //       );
    //       setOpenSnack(true);
    //       setNoData(true);
    //     }
    //   });
  };

  const loadRoutinesForRoom = (roomId) => {
    if (!roomId) {
      return;
    }
    setRoutineChartLoading(true);
    setRoutineChartError("");
    getRoutinesByRoomId(roomId)
      .then((response) => {
        setRoutines(
          sortRoutinesByActionTimeAsc(response.data.routines || [])
        );
      })
      .catch(() => {
        setRoutineChartError("Unable to load routines");
        setRoutines([]);
      })
      .finally(() => {
        setRoutineChartLoading(false);
      });
  };

  const handleWeeks = (e, val) => {
    console.log("week-name:" + val);
    setWeeks(val);
  };

  const handleClickOpen = () => {
    setOpen(true);
    setIsVisible(false);
  };

  const handleSpectrumOpen = () => {
    console.log("spectrum " + JSON.stringify(spectrumNameAct));
    setOpenSpectrum(true);
    setIsVisible(false);
  };

  const handleClose = () => {
    setOpen(false);
    // setIsVisible(false);
    // !open ? setIsVisible(false) : setIsVisible(false);
  };

  const handleCloseRoutines = () => {
    setRoutineTime(dayjs(new Date()));
    setRoutineNameInput("");
    setRoutineAction(1);
    setRoomNameRot("");
    setSpectrumNameRot("");
    setWeekValues([0, 0, 0, 0, 0, 0, 0]);
    setOpen(!open);
  };

  const handleSpectrumClose = () => {
    setSpectrumNameText("");
    setOpenSpectrum(false);
    // !openSpectrum ? setIsVisible(false) : setIsVisible(false);
  };

  const handleSaveAlert = () => {
    console.log("handle save");
    window.addEventListener("beforeunload", handleBeforeUnload);
    setAlertFlag(true);
    const specData = {
      roomId: activeRoom.roomId,
      spectrumId: spectrumNameAct.spectrumControlId,
    };
    console.log("cached--spectrum " + JSON.stringify(specData));
    setSpectrumData(specData);
  };

  const handleChange = (event) => {
    console.log("toggle-val:" + event.target.value.spectrumControlId);

    if (roles.includes("edit-spectrum")) {
      const updateSpectrumData = {
        spectrumControlId: event.target.value.spectrumControlId,
      };
      // console.log("updateSpectrumData: ")
      updateSpectrumRoomData(activeRoom.roomId, updateSpectrumData)
        .then(function (response) {
          if (response.data.spectrum.orgCode == "SUPER_ADMIN") {
            setSpectrumSaveDisabled(true);
          }
          setSpectrum(response.data.spectrum.channelData);
          ratioCacheRef.current = [];

          setLockRatio(response.data.spectrum.lockRatio);
          if (response.data.spectrum.lockRatio != 0) {
            // const max_index = response.data.spectrum.channelData.indexOf(
            //   response.data.spectrum.channelData.reduce(function (
            //     prev,
            //     current
            //   ) {
            //     return prev && prev.channelValue > current.channelValue
            //       ? prev
            //       : current;
            //   })
            // );
            let max_index = -1;
            let max = -Infinity;
            response.data.spectrum.channelData.forEach((obj, index) => {
              if (obj.isActive && obj.channelValue > max) {
                max = obj.channelValue;
                max_index = index;
              }
            });
            if (max_index == -1) {
              max_index = 0;
            }
            console.log("max val: " + max_index);
            setMasterSpectrumIndex(max_index);
          }

          getRooms()
            .then(function (response) {
              console.log("room: " + JSON.stringify(response.data.rooms));

              const cached_room_id = localStorage.getItem("cached_room");
              console.log("cached-room: " + cached_room_id);

              setRoomNames(response.data.rooms);
              let foundIndex = response.data.rooms.findIndex(
                (item) => item.roomId == cached_room_id
              );
              console.log("foundIndex: " + foundIndex);
              if (foundIndex !== -1) {
                console.log("room found - " + foundIndex);
                setActiveRoom(response.data.rooms[foundIndex]);
              } else {
                setActiveRoom(response.data.rooms[0]);
                foundIndex = 0;
                console.log("room not found");
              }
              // setRoomNames(response.data.rooms);
            })
            .catch((error) => {
              console.log("service-error", error);
              if (!error.response) {
                setopenSnackErrMsg("No Data found");
                setOpenSnack(true);
                setNoData(true);
              } else {
                setopenSnackErrMsg(
                  error.response.data.code + " - Please try again later"
                );
                setOpenSnack(true);
                setNoData(true);
              }
            });

          // setSpectrumNameAct(response.data.spectrum);4
          console.log("Spect-act:" + JSON.stringify(event.target.value));
          setSpectrumNameAct(event.target.value);
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
          } else {
            setopenSnackErrMsg(
              error.response.data.code + " - Please try again later"
            );
            setOpenSnack(true);
          }
        });
    }
  };

  const parseSliderTargetValue = (e, explicitValue) => {
    if (typeof explicitValue === "number" && Number.isFinite(explicitValue)) {
      return explicitValue;
    }
    const raw = e?.target?.value;
    if (raw === undefined || raw === null || raw === "") {
      return null;
    }
    const n = typeof raw === "number" ? raw : parseFloat(String(raw));
    return Number.isFinite(n) ? n : null;
  };

  const mergeSpectrumChannelValues = (prev, newValue, channelIndex) => {
    if (!lockRatio) {
      return prev.map((ch, i) =>
        i === channelIndex ? { ...ch, channelValue: newValue } : ch
      );
    }

    const baseNum = Number(prev[channelIndex]?.channelValue);
    const canCalculate = Number.isFinite(baseNum) && baseNum !== 0;

    const ratios = canCalculate
      ? prev.map((v, idx) => {
          if (!v.isActive) {
            return 0;
          }
          if (idx === channelIndex) {
            return 1;
          }
          const cv = Number(v.channelValue);
          return Number.isFinite(cv) ? cv / baseNum : 0;
        })
      : Array.isArray(ratioCacheRef.current) &&
        ratioCacheRef.current.length === prev.length
      ? ratioCacheRef.current
      : prev.map((v) => (v.isActive ? 1 : 0));

    if (canCalculate) {
      ratioCacheRef.current = ratios;
    }

    return prev.map((ch, i) => {
      if (!ch.isActive) {
        return ch;
      }
      const factor = ratios[i] ?? 0;
      return { ...ch, channelValue: newValue * factor };
    });
  };

  const applySpectrumValueAtIndex = (newValue, channelIndex) => {
    setSpectrum((prev) =>
      mergeSpectrumChannelValues(prev, newValue, channelIndex)
    );
  };

  const persistSpectrumChangeNow = (channelDataArray) => {
    if (!spectrumNameAct?.spectrumControlId) {
      return;
    }
    const updateSpectrumData = {
      channelData: JSON.stringify(channelDataArray),
      lockRatio: lockRatio,
      roomId: activeRoom.roomId,
    };

    changeSpectrum(spectrumNameAct.spectrumControlId, updateSpectrumData)
      .then(function (response) {
        console.log("update spectrum" + response.data.code);
        if (response.data.code === "SPECTRUM_UPDATE_FAIL") {
          setopenSnackErrMsg("Failed to update Spectrum Data");
          setOpenSnack(true);
        } else {
          setopenSnackErrMsg("Successfully updated spectrum data");
          setOpenSnack(true);
        }
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
        }
      });
  };

  const handleSliderChange = (e, channelIndex, explicitValue, meta) => {
    if (!roles.includes("edit-spectrum")) {
      return;
    }
    const newValue = parseSliderTargetValue(e, explicitValue);
    if (newValue === null) {
      return;
    }
    setSpectrumSaveDisabled(false);
    handleSaveAlert();

    let nextSnapshot = null;
    setSpectrum((prev) => {
      nextSnapshot = mergeSpectrumChannelValues(prev, newValue, channelIndex);
      return nextSnapshot;
    });

    if (meta?.fromArrow && nextSnapshot) {
      persistSpectrumChangeNow(nextSnapshot);
    }
  };

  const handleInputChange = (event, channelIndex) => {
    if (!roles.includes("edit-spectrum")) {
      return;
    }
    const newValue = parseFloat(String(event?.target?.value ?? ""));
    if (!Number.isFinite(newValue)) {
      return;
    }
    setSpectrumSaveDisabled(false);
    handleSaveAlert();
    applySpectrumValueAtIndex(newValue, channelIndex);
  };

  const debounceInputChange = () => {
    console.log("Timeout: " + timeoutId1);
    clearTimeout(timeoutId1);
    timeoutId1 = setTimeout(() => {
      // Perform action or update state once input change is completed
      console.log("Input change completed:");
      handleChangeComplete();
      // You can update state or perform any other action here
    }, 3000); // Adjust the timeout value as needed
  };

  const editLableName = (event, index) => {
    setOpenEditName(!openEditName);
    const edit_lable = {
      index: index,
      channelName: spectrum[index].channelName,
    };
    setEditedChannelName(spectrum[index].channelName);
    setLableData(edit_lable);
  };

  const changeSliderState = (event, index) => {
    console.log("checkbox clicked");
    if (roles.includes("edit-spectrum")) {
      setSpectrumSaveDisabled(false);
      handleSaveAlert();
      setSpectrum((prevValues) => {
        const newValues = [...prevValues];
        newValues[index].isActive = !newValues[index].isActive;
        newValues[index].channelValue = 1;
        return newValues;
      });
    }
  };

  const handleAddSlider = () => {
    if (roles.includes("edit-spectrum")) {
      const nextIndex = spectrum.findIndex((value) => !value.isActive);
      if (nextIndex === -1) {
        return;
      }
      setSpectrumSaveDisabled(false);
      handleSaveAlert();
      setSpectrum((prevValues) => {
        const newValues = [...prevValues];
        newValues[nextIndex].isActive = true;
        if (newValues[nextIndex].channelValue === 0) {
          newValues[nextIndex].channelValue = 1;
        }
        return newValues;
      });
    }
  };

  const handleChannelNameChange = (event, index) => {
    if (roles.includes("edit-spectrum")) {
      setSpectrumSaveDisabled(false);
      handleSaveAlert();
      const newName = event.target.value;
      setSpectrum((prevValues) => {
        const newValues = [...prevValues];
        newValues[index].channelName = newName;
        return newValues;
      });
    }
  };

  const handleRemoveSlider = (index) => {
    if (roles.includes("edit-spectrum")) {
      setSpectrumSaveDisabled(false);
      handleSaveAlert();
      setSpectrum((prevValues) => {
        const newValues = [...prevValues];
        newValues[index].isActive = false;
        newValues[index].channelName = "";
        return newValues;
      });
    }
  };

  const saveSpectrumData = () => {
    if (roles.includes("edit-spectrum")) {
      const updateSpectrumData = {
        channelData: JSON.stringify(spectrum),
        lockRatio: lockRatio,
        roomId: activeRoom.roomId,
      };
      // console.log("updateSpectrumData: ")
      updateSpectrum(spectrumNameAct.spectrumControlId, updateSpectrumData)
        .then(function (response) {
          console.log("update spectrum" + response.data.code);
          if (response.data.code === "SPECTRUM_UPDATE_FAIL") {
            setopenSnackErrMsg("Failed to update Spectrum Data");
            setOpenSnack(true);
          } else {
            setSpectrumSaveDisabled(true);
            setopenSnackErrMsg("Successfully updated spectrum data");
            setOpenSnack(true);
          }
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
          } else {
            setopenSnackErrMsg(
              error.response.data.code + " - Please try again later"
            );
            setOpenSnack(true);
          }
        });
    }
  };

  const handleBlur = () => {
    console.log("On Blur");
    if (value < 0) {
      setValue(0);
    } else if (value > 100) {
      setValue(100);
    }
    handleChangeComplete();
    handleSaveAlert();
  };

  const handleChangeComplete = () => {
    console.log("Change event completed");
    persistSpectrumChangeNow(spectrum);
  };

  const handleClick = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  const showAddOptions = () => {
    setIsVisible(!isVisible);
  };

  const changeRatioState = () => {
    if (roles.includes("edit-spectrum")) {
      console.log(lockRatio);
      const updateSpectrumData = {
        channelData: JSON.stringify(spectrum),
        lockRatio: !lockRatio,
        roomId: spectrumNameAct.roomId,
      };

      if (!lockRatio != 0) {
        // const max_index = spectrum.indexOf(
        //   spectrum.reduce(function (prev, current) {
        //     return prev && prev.channelValue > current.channelValue
        //       ? prev
        //       : current;
        //   })
        // );

        let max_index = -1;
        let max = -Infinity;
        spectrum.forEach((obj, index) => {
          if (obj.isActive && obj.channelValue > max) {
            max = obj.channelValue;
            max_index = index;
          }
        });
        if (max_index == -1) {
          max_index = 0;
        }

        console.log("max val: " + max_index);
        setMasterSpectrumIndex(max_index);
      }

      updateSpectrum(spectrumNameAct.spectrumControlId, updateSpectrumData)
        .then(function (response) {
          console.log("update spectrum" + response.data.code);
          if (response.data.code === "SPECTRUM_UPDATE_FAIL") {
            setopenSnackErrMsg("Failed to update Spectrum Data");
            setOpenSnack(true);
          } else {
            setLockRatio(!lockRatio);
            setopenSnackErrMsg("Successfully updated spectrum data");
            setOpenSnack(true);
          }
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
          } else {
            setopenSnackErrMsg(
              error.response.data.code + " - Please try again later"
            );
            setOpenSnack(true);
          }
        });
    }
  };

  const handleActionChange = (event, action) => {
    setRoutineAction(action);
  };

  const handleRoutineNameChange = (event) => {
    setRoutineNameInput(event.target.value);
  };

  const handleSave = () => {
    console.log(routineNameInput);
    console.log(routineTime);
    console.log(routineAction);
    console.log(roomName);
    console.log(spectrumName);

    setOpen(!open);
  };

  const handleSpectrumChange = (event) => {
    setSpectrumNameRot(event.target.value);
  };

  const handleEditClose = () => {
    setOpenEditName(!openEditName);
  };

  const handleEditSave = (event, index) => {
    setSpectrum((prevValues) => {
      const newValues = [...prevValues];
      newValues[lableData.index].channelName = editedChannelName;
      return newValues;
    });

    const updateSpectrumData = {
      channelData: JSON.stringify(spectrum),
      lockRatio: lockRatio,
      roomId: spectrumNameAct.roomId,
    };

    updateSpectrum(spectrumNameAct.spectrumControlId, updateSpectrumData)
      .then(function (response) {
        console.log("update spectrum" + response.data.code);
        if (response.data.code === "SPECTRUM_UPDATE_FAIL") {
          setopenSnackErrMsg("Failed to update Spectrum Data");
          setOpenSnack(true);
        } else {
          setOpenEditName(!openEditName);
          setopenSnackErrMsg("Successfully updated spectrum name");
          setOpenSnack(true);
        }
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
        }
      });
  };

  const handleLableChange = (event) => {
    setEditedChannelName(event.target.value);
  };

  const handleWeekCheckbox = (event, index) => {
    setWeekValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[index] = 1;
      return newValues;
    });
    console.log(weekValues);
  };

  const handleSaveRoutines = () => {
    var utc = require("dayjs/plugin/utc");
    dayjs.extend(utc);
    // console.log(dayjs.utc().format());
    console.log("name" + routineNameInput);
    // console.log(dayjs.utc(routineTime).format().split("T")[1].split("Z")[0]);
    // console.log("rot: " + routineTime);
    // console.log(routineAction);
    console.log(roomName);
    console.log(spectrumName);
    // console.log(weekValues);
    if (routineNameInput != "" && roomNameRot && spectrumNameRot) {
      const routine_data = {
        routineName: routineNameInput,
        action: parseInt(routineAction),
        daysInWeek: weekValues.toString(),
        spectrumId: spectrumName.spectrumId,
        spectrumName: spectrumName.spectrumName,
        actionTime: dayjs.utc(routineTime).format().split("T")[1].split("Z")[0],
        roomId: roomName.roomId,
      };
      createRoutine(routine_data)
        .then(function (response) {
          setOpen(!open);
          setopenSnackErrMsg("Successfully Created routine");
          setOpenSnack(true);
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
            setNoData(true);
          } else {
            setopenSnackErrMsg(
              error.response.data.code + " - Please try again later"
            );
            setOpenSnack(true);
            setNoData(true);
          }
        });
    } else {
      setopenSnackErrMsg("Please enter valid data to continue");
      setOpenSnack(true);
    }
  };

  const handleRoomChangeRoutine = (event) => {
    getAllSpectrum()
      .then(function (response) {
        console.log(response.data.spectrums);
        setRoomNameRot(event.target.value);
        setSpectrumNamesRot(response.data.spectrums);
        setSpectrumNameRot(response.data.spectrums[0]);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          noSpectrumData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoSpectrumData(true);
        }
      });
  };

  const handleNewSpectrum = () => {
    const spectrum_data = {
      roomId: activeRoom.roomId,
      lockRatio: lockRatio,
      spectrumName: spectrumNameText,
      spectrumControl: JSON.stringify(spectrum),
    };
    createSpectrum(activeRoom.roomId, spectrum_data)
      .then(function (response) {
        setOpenSpectrum(false);

        setopenSnackErrMsg("Successfully created Spectrum ");
        setOpenSnack(true);
        window.location.reload(false);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.message + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });
  };

  const handleUpdateSpectrum = () => {
    const spectrum_data = {
      roomId: roomDetails.roomId,
      spectrumControlId: spectrumNameAct.spectrumControlId,
    };
    updateSpectrum(roomDetails.roomId, spectrum_data)
      .then(function (response) {
        setOpenSpectrum(false);
        setopenSnackErrMsg("Successfully updated Spectrum ");
        setOpenSnack(true);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });
  };

  const handleRefresh = () => {
    window.location.reload(false);
  };

  const handleSpectrumNameText = (event) => {
    setSpectrumNameText(event.target.value);
  };

  const snackAction = (
    <Fragment>
      {/* <Button color="secondary" size="small" onClick={handleCloseSnack}>
        UNDO
      </Button> */}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnack}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  const luxValue = formatIntegerValue(
    getSelectedValueForKey(selectedLuxDevice, "lux")
  );
  const ppfdValue = formatIntegerValue(
    getSelectedValueForKey(selectedSensorDevice, "ppfd")
  );
  const roomTempValue = formatOneDecimalValue(
    getSelectedValueForKey(selectedTempDevice, "roomTemperature")
  );
  const roomHumidityRaw = getSelectedValueForKey(
    selectedHumidityDevice,
    "roomHumidity"
  );
  const roomHumidityValue =
    roomHumidityRaw == null || !Number.isFinite(roomHumidityRaw)
      ? "NA"
      : String(Math.round(roomHumidityRaw));
  const dliLastDayValue = formatOneDecimalValue(getSelectedLastDayField("dliTotal"));
  const photoperiodHours = computePhotoperiodHours(routines);
  const photoperiodValue =
    photoperiodHours == null ? "NA" : formatOneDecimalValue(photoperiodHours);

  return (
    <Box sx={{ width: "100%", minWidth: 0, mt: -1.5 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{
          mt: 0,
          flexWrap: { xs: "wrap", sm: "nowrap" },
          rowGap: { xs: 0.5, sm: 0 },
        }}
      >

        {/* <ToggleButtonGroup
          size="medium"
          color="primary"
          exclusive
          value={activeRoom}
          onChange={handleRoomChange}
          aria-label="text alignment"
          // sx={{ background: "#EBEBE4" }}
        >
          {roomNames.map((rooms, index) => (
            <ToggleButton value={rooms} aria-label={rooms.roomLable}>
              {rooms.roomName}
            </ToggleButton>
          ))}
        </ToggleButtonGroup> */}

        <Paper
          elevation={0}
          sx={{
            display: "flex",
            border: (theme) => `2px solid ${theme.palette.divider}`,
            flexWrap: "wrap",
            width: { xs: "100%", sm: "auto" },
            overflowX: "auto",
          }}
        >
          <StyledToggleButtonGroup
            size="small"
            value={activeRoom}
            exclusive
            onChange={handleRoomChange}
            aria-label="text alignment"
            sx={{
              flexWrap: "wrap",
              width: { xs: "100%", sm: "auto" },
              "& .MuiToggleButton-root": {
                fontSize: 11,
                px: 1,
                py: 0.4,
                minHeight: 28,
              },
            }}
          >
            {roomNames.map((rooms, index) => (
              <ToggleButton value={rooms} aria-label={rooms.roomLable}>
                {rooms.roomName}
              </ToggleButton>
            ))}
          </StyledToggleButtonGroup>
          {/* <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            {roomNames.map((rooms, index) => (
              <Grid item xs>
                <Button variant="outlined" size="small">
                  Room
                </Button>
              </Grid>
            ))}
          </Grid> */}
        </Paper>

        <Button
          variant="contained"
          size="small"
          onClick={handleRefresh}
          disabled={!roles.includes("add-spectrum")}
          sx={{
            width: { xs: "100%", sm: "auto" },
            fontSize: 11,
            height: 28,
            px: 1,
          }}
        >
          <RefreshIcon />
          &nbsp;Refresh
        </Button>
      </Stack>
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        message={openSnackErrMsg}
        action={snackAction}
      />
      <Stack
        direction="row"
        spacing={2}
        mb={0.5}
        justifyContent="center"
        alignItems="center"
      ></Stack>

      <Dialog open={open} onClose={handleCloseRoutines} fullWidth maxWidth="sm" PaperProps={{ sx: { m: { xs: 1 }, maxHeight: "90vh" } }}>
        <DialogTitle sx={{ pr: 6 }}>Create Routine</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseRoutines}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ overflowY: "auto" }}>
          <TextField
            autoFocus
            margin="dense"
            size="small"
            id="routine_name"
            label="Routine Name"
            type="routine_name"
            fullWidth
            value={routineNameInput}
            onChange={handleRoutineNameChange}
            variant="outlined"
          />

          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            mt={0.5}
          >
            <Grid item xs={12} sm={6}>
              <FormControl sx={{ minWidth: { xs: 0, sm: 250 }, width: "100%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileTimePicker
                    value={routineTime}
                    onChange={(newValue) => setRoutineTime(newValue)}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ToggleButtonGroup
                color="primary"
                value={routineAction}
                exclusive
                size="large"
                align="center"
                justifyContent="center"
                onChange={handleActionChange}
                aria-label="Platform"
                // sx={{ mt: 1 }}
              >
                <ToggleButton value="ON">ON</ToggleButton>
                <ToggleButton value="OFF">OFF</ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth sx={{ minWidth: 0, mt: 1 }}>
                <InputLabel id="demo-simple-select-label">
                  Choose Room
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={roomNameRot}
                  label="Choose Room"
                  onChange={handleRoomChangeRoutine}
                >
                  {noRoomData ? (
                    <em>
                      <MenuItem value="NaNa">No Data Found</MenuItem>
                    </em>
                  ) : (
                    roomNames.map((rooms, index) => (
                      <MenuItem value={rooms}>{rooms.roomName}</MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth sx={{ minWidth: 0, mt: 1 }}>
                <InputLabel id="demo-simple-select-label">
                  Choose Spectrum
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={spectrumNameRot}
                  label="Choose Spectrum"
                  onChange={handleSpectrumChange}
                >
                  {spectrumNamesRot.length < 1 ? (
                    <em>
                      <MenuItem value="">No Data Found</MenuItem>
                    </em>
                  ) : (
                    spectrumNamesRot.map((spectrumValue, index) =>
                      spectrumValue.status == 1 ? (
                        <MenuItem value={spectrumValue}>
                          {spectrumValue.spectrumName} <em>&nbsp;(Active) </em>
                        </MenuItem>
                      ) : (
                        <MenuItem value={spectrumValue}>
                          {spectrumValue.spectrumName}
                        </MenuItem>
                      )
                    )
                  )}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}></Grid>
          </Grid>
          <Box sx={{ ml: { xs: 0, sm: 2 }, mt: 1, width: "100%", overflowX: "auto" }}>
            <FormGroup aria-label="position" row>
              {weekDays.map((day, index) => (
                <FormControlLabel
                  value={day}
                  control={<Checkbox />}
                  label={day}
                  onClick={(e) => handleWeekCheckbox(e, index)}
                  labelPlacement="end"
                />
              ))}
            </FormGroup>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRoutines}>Cancel</Button>
          <Button onClick={handleSaveRoutines}>Save</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openSpectrum} onClose={handleSpectrumClose} fullWidth maxWidth="xs" PaperProps={{ sx: { m: 1 } }}>
        <DialogTitle sx={{ ml: 1, mt: 1, pr: 6 }}>Save Spectrum As</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleSpectrumClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            size="small"
            id="spectrum_name"
            label="Spectrum Name"
            type="spectrum_name"
            fullWidth
            variant="outlined"
            value={spectrumNameText}
            onChange={handleSpectrumNameText}
          />
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            mt={0.5}
          >
            <Grid item xs={6}></Grid>
            <Grid item xs={6}></Grid>
            <Grid item xs={6}></Grid>
            <Grid item xs={6}></Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ mb: 1, mr: 1 }}>
          <Button onClick={handleSpectrumClose}>Cancel</Button>
          <Button onClick={handleNewSpectrum}>Save</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditName} onClose={handleEditClose} fullWidth maxWidth="xs" PaperProps={{ sx: { m: 1 } }}>
        <DialogTitle sx={{ pr: 6 }}>Edit Name</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleEditClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Box sx={{ minWidth: 0, width: "100%" }}>
            <TextField
              autoFocus
              margin="dense"
              size="small"
              id="name"
              label="Name"
              type="name"
              fullWidth
              value={editedChannelName}
              onChange={handleLableChange}
              variant="outlined"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose}>Cancel</Button>
          <Button onClick={handleEditSave}>Add</Button>
        </DialogActions>
      </Dialog>

      <Grid container spacing={1} alignItems="stretch">
        <Grid item xs={12} md={4}>
          <Box sx={{ height: "100%" }}>
            <Paper
              elevation={2}
              sx={{
                borderRadius: 0.75,
                px: { xs: 1.25, sm: 1.5, md: 2 },
                pb: { xs: 1, md: 1.25 },
                pt: { xs: 1.5, md: 2 },
                height: { md: "100%" },
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Stack
                direction="row"
                spacing={0.75}
                mb={0.5}
                mt={-0.5}
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                useFlexGap
                sx={{ gap: 0.75 }}
              >
                <FormControl
                  size="small"
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    maxWidth: "100%",
                    "& .MuiSelect-select": { fontSize: 11 },
                    "& .MuiInputLabel-root": { fontSize: 11 },
                  }}
                >
                  <InputLabel id="demo-simple-select-label">Spectrum</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={spectrumNameAct}
                    label="Spectrum"
                    size="small"
                    onChange={handleChange}
                    sx={{ height: 26 }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          "& .MuiMenuItem-root": {
                            fontSize: 11,
                            fontFamily: "inherit",
                          },
                          "& .MuiList-root": {
                            padding: 0.5,
                          },
                        },
                      },
                    }}
                  >
                    {spectrumNames.map((spectrumValue, index) => (
                      <MenuItem key={spectrumValue?.spectrumControlId ?? index} value={spectrumValue} sx={{ fontSize: 11 }}>
                        {spectrumValue.spectrumName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Stack direction="row" spacing={0.5} alignItems="center" flexShrink={0}>
                  <FormGroup sx={{ m: 0 }}>
                    <FormControlLabel
                      control={
                        <Checkbox checked={lockRatio} onClick={changeRatioState} size="small" />
                      }
                      label="Set Ratio"
                      sx={{ "& .MuiFormControlLabel-label": { fontSize: 10 } }}
                    />
                  </FormGroup>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={saveSpectrumData}
                    disabled={spectrumSaveDisabled}
                    sx={{ height: 24, fontSize: 9, px: 0.75, minWidth: 48 }}
                  >
                    <SaveIcon sx={{ fontSize: 12 }} />
                    &nbsp;SAVE
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleSpectrumOpen}
                    disabled={!roles.includes("add-spectrum")}
                    sx={{ height: 24, fontSize: 9, px: 0.75, minWidth: 44 }}
                  >
                    <SaveAsIcon sx={{ fontSize: 12 }} />
                    &nbsp;New
                  </Button>
                </Stack>
              </Stack>

          {spectrumNameAct?.spectrumName === "Spectrum Off" ? (
            <Box sx={{ py: 2, px: 1, textAlign: "center", width: "100%" }}>
              <Typography variant="body2" color="text.secondary">
                All wavelengths Set to OFF
              </Typography>
            </Box>
          ) : (
          <>
          <Grid
            container
            spacing={{ xs: 0.35, md: 0.35 }}
            columns={{ xs: 4, sm: 4, md: 4 }}
            sx={{ flex: 1, alignContent: "flex-start" }}
          >
                {spectrum
                  .map((value, index) => ({ value, index }))
                  .filter(({ value }) => value.isActive)
                  .map(({ value, index }) => (
                <Grid item xs={4} sm={4} md={4} key={index}>
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "100%",
                          mx: "auto",
                          px: 0.1,
                          py: 0.1,
                          position: "relative",
                          "&:hover .slider-close": { opacity: 1 },
                          border:
                            lockRatio == 1 && index == masterSpectrumIndex
                              ? "2px solid"
                              : "none",
                          borderColor:
                            lockRatio == 1 && index == masterSpectrumIndex
                              ? "warning.main"
                              : "transparent",
                        }}
                      >
                  <Paper elevation={2} className="slider-tile" sx={{ p: 0.4, borderRadius: 0.5 }}>
                          {index !== 0 && (
                            <IconButton
                              className="slider-close"
                              size="small"
                              onClick={() => handleRemoveSlider(index)}
                              sx={{
                                position: "absolute",
                                top: -10,
                                right: -10,
                                opacity: 0,
                                transition: "opacity 0.2s ease",
                                bgcolor: "rgba(255, 255, 255, 0.9)",
                                boxShadow: "0 4px 10px rgba(15, 23, 42, 0.18)",
                                "&:hover": { bgcolor: "rgba(255, 255, 255, 1)" },
                                width: 18,
                                height: 18,
                              }}
                            >
                              <CloseIcon sx={{ fontSize: 10 }} />
                            </IconButton>
                          )}
                          <Stack
                            direction="row"
                            spacing={0.5}
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <FormControl size="small">
                              <Select
                                value={
                                  channelColorMap[value.channelName]
                                    ? value.channelName
                                    : ""
                                }
                                displayEmpty
                                onChange={(event) =>
                                  handleChannelNameChange(event, index)
                                }
                                renderValue={(selected) =>
                                  selected ? (
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: 10,
                                        fontWeight: 700,
                                        color: "#0B0F1A",
                                      }}
                                    >
                                      {selected}
                                    </Typography>
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ fontSize: 10 }}
                                    >
                                      Select name
                                    </Typography>
                                  )
                                }
                                sx={{
                                  minWidth: 96,
                                  "& .MuiSelect-icon": { opacity: 0 },
                                  "&:hover .MuiSelect-icon": { opacity: 1 },
                                  "& .MuiSelect-select": {
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: 10,
                                    py: 0.25,
                                  },
                                }}
                          >
                            {channelOptions.map((option) => {
                              const isTaken =
                                spectrum.some(
                                  (item) =>
                                    item.isActive &&
                                    item.channelName === option.name
                                ) && option.name !== value.channelName;
                              return (
                                <MenuItem
                                  key={option.name}
                                  value={option.name}
                                  disabled={isTaken}
                                >
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                  >
                                    <Box
                                      sx={{
                                        width: 9,
                                        height: 9,
                                        borderRadius: "50%",
                                        bgcolor: option.color,
                                      }}
                                    />
                                    <Typography variant="body2" sx={{ fontSize: 12 }}>
                                      {option.name}
                                    </Typography>
                                  </Stack>
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                            <Stack
                              direction="column"
                              spacing={0}
                              alignItems="center"
                              sx={{
                                transition: "opacity 0.2s ease",
                                "@media (hover: none)": {
                                  opacity: 1,
                                  pointerEvents: "auto",
                                },
                                "@media (hover: hover)": {
                                  opacity: 0,
                                  pointerEvents: "none",
                                  ".slider-tile:hover &": {
                                    opacity: 1,
                                    pointerEvents: "auto",
                                  },
                                },
                              }}
                            >
                              <IconButton
                                type="button"
                                size="small"
                                onMouseDown={(ev) => {
                                  ev.preventDefault();
                                  ev.stopPropagation();
                                }}
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  ev.stopPropagation();
                                  const cur = Number(value.channelValue);
                                  const base = Number.isFinite(cur) ? cur : 0;
                                  handleSliderChange(
                                    null,
                                    index,
                                    Math.min(100, base + 1),
                                    { fromArrow: true }
                                  );
                                }}
                                sx={{ width: 28, height: 22, p: 0, minWidth: 28 }}
                              >
                                <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                              <IconButton
                                type="button"
                                size="small"
                                onMouseDown={(ev) => {
                                  ev.preventDefault();
                                  ev.stopPropagation();
                                }}
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  ev.stopPropagation();
                                  const cur = Number(value.channelValue);
                                  const base = Number.isFinite(cur) ? cur : 0;
                                  handleSliderChange(
                                    null,
                                    index,
                                    Math.max(0, base - 1),
                                    { fromArrow: true }
                                  );
                                }}
                                sx={{ width: 28, height: 22, p: 0, minWidth: 28 }}
                              >
                                <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </Stack>
                          <Box
                            sx={{
                              minWidth: 44,
                              textAlign: "right",
                              fontSize: 14,
                              fontWeight: 700,
                              pr: 0.5,
                              mr: 1,
                            }}
                          >
                            {value.channelValue >= 100
                              ? 100
                              : Math.round(value.channelValue)}
                            <Box component="span" sx={{ ml: 0.2 }}>
                              %
                            </Box>
                          </Box>
                      </Stack>

                      <Grid
                        container
                        spacing={0.5}
                        alignItems="center"
                        sx={{ px: 1 }}
                      >
                        <Grid item xs>
                          <Slider
                            size="small"
                            step={1}
                            min={0}
                            max={100}
                            value={(() => {
                              const n = Number(value.channelValue);
                              if (!Number.isFinite(n)) {
                                return 0;
                              }
                              return n >= 100 ? 100 : Math.round(n);
                            })()}
                            onChange={(e, val) => handleSliderChange(e, index, val)}
                            onChangeCommitted={handleChangeComplete}
                            valueLabelDisplay="auto"
                            aria-labelledby="input-slider"
                            disabled={!value.isActive}
                            sx={{
                              mx: 0,
                              color:
                                channelColorMap[value.channelName] ||
                                "primary.main",
                              height: 6,
                              "& .MuiSlider-rail, & .MuiSlider-track": {
                                height: 6,
                              },
                              "& .MuiSlider-thumb": {
                                width: 15,
                                height: 15,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                      {lockRatio == 1 && index == masterSpectrumIndex && (
                        <Typography
                          variant="caption"
                          display="block"
                          gutterBottom
                          color={"primary.main"}
                          sx={{ fontWeight: "bold", mt: -0.5, mb: -0.5, fontSize: 10 }}
                        >
                          Master Slider
                        </Typography>
                      )}
                    </Paper>
                  </Box>
                </Grid>
              ))}
          </Grid>
          <Stack direction="row" justifyContent="center" mt={0.75} mb={0}>
            <IconButton
              color="primary"
              onClick={handleAddSlider}
              disabled={
                !roles.includes("edit-spectrum") ||
                !spectrum.some((value) => !value.isActive)
              }
              sx={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                bgcolor: "primary.main",
                color: "primary.contrastText",
                boxShadow: "0 8px 18px rgba(15, 23, 42, 0.18)",
                "&:hover": { bgcolor: "primary.dark" },
                "&.Mui-disabled": {
                  bgcolor: "action.disabledBackground",
                  color: "action.disabled",
                },
              }}
            >
              <AddIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Stack>
          </>
          )}
            </Paper>
          </Box>
        </Grid>
        <Grid item xs={12} md={8} sx={{ minWidth: 0 }}>
          <Stack spacing={1} sx={{ height: { md: "100%" }, minHeight: 0, width: "100%" }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
                gap: 1,
                flexShrink: 0,
                width: "100%",
                minWidth: 0,
              }}
            >
              <Paper
                elevation={2}
                sx={{
                  p: 1,
                  borderRadius: 0.75,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ flexWrap: "nowrap", rowGap: 0.5, minWidth: 0 }}
                >
                  <Typography variant="subtitle2" color="text.secondary" noWrap sx={{ flexShrink: 0 }}>
                    Lux
                  </Typography>
                  <FormControl
                    size="small"
                    sx={{
                      minWidth: 90,
                      flex: 1,
                      maxWidth: "100%",
                      "& .MuiSelect-select": { fontSize: 11 },
                      "& .MuiInputLabel-root": { fontSize: 11 },
                    }}
                  >
                    <InputLabel id="lux-device-select-label">Sensor Device</InputLabel>
                    <Select
                      labelId="lux-device-select-label"
                      value={selectedLuxDevice}
                      label="Sensor Device"
                      onChange={handleLuxDeviceChange}
                      sx={{ height: 26 }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root": { fontSize: 11, fontFamily: "inherit" },
                            "& .MuiList-root": { padding: 0.5 },
                          },
                        },
                      }}
                    >
                      <MenuItem value="Average" sx={{ fontSize: 11 }}>Average</MenuItem>
                      {activeRoomSensorDevices.map((device) => (
                        <MenuItem
                          key={device.deviceSerialNo}
                          value={device.deviceSerialNo}
                          sx={{ fontSize: 11 }}
                        >
                          {device.deviceName || device.deviceSerialNo}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Typography variant="h6" sx={{ mt: 0.5, fontWeight: 700 }}>
                  {luxValue === "NA" ? "NA" : `${luxValue} lx`}
                </Typography>
              </Paper>
              <Paper
                elevation={2}
                sx={{
                  p: 1,
                  borderRadius: 0.75,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ flexWrap: "nowrap", rowGap: 0.5, minWidth: 0 }}
                >
                  <Typography variant="subtitle2" color="text.secondary" noWrap sx={{ flexShrink: 0 }}>
                    Room Temperature
                  </Typography>
                  <FormControl
                    size="small"
                    sx={{
                      minWidth: 90,
                      flex: 1,
                      maxWidth: "100%",
                      "& .MuiSelect-select": { fontSize: 11 },
                      "& .MuiInputLabel-root": { fontSize: 11 },
                    }}
                  >
                    <InputLabel id="room-temp-select-label">Sensor Device</InputLabel>
                    <Select
                      labelId="room-temp-select-label"
                      value={selectedTempDevice}
                      label="Sensor Device"
                      onChange={handleTempDeviceChange}
                      sx={{ height: 26 }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root": { fontSize: 11, fontFamily: "inherit" },
                            "& .MuiList-root": { padding: 0.5 },
                          },
                        },
                      }}
                    >
                      <MenuItem value="Average" sx={{ fontSize: 11 }}>Average</MenuItem>
                      {activeRoomSensorDevices.map((device) => (
                        <MenuItem
                          key={device.deviceSerialNo}
                          value={device.deviceSerialNo}
                          sx={{ fontSize: 11 }}
                        >
                          {device.deviceName || device.deviceSerialNo}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Typography variant="h6" sx={{ mt: 0.5, fontWeight: 700 }}>
                  {roomTempValue === "NA" ? "NA" : `${roomTempValue} °C`}
                </Typography>
              </Paper>
              <Paper
                elevation={2}
                sx={{
                  p: 1,
                  borderRadius: 0.75,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ flexWrap: "nowrap", rowGap: 0.5, minWidth: 0 }}
                >
                  <Typography variant="subtitle2" color="text.secondary" noWrap sx={{ flexShrink: 0 }}>
                    Room Humidity
                  </Typography>
                  <FormControl
                    size="small"
                    sx={{
                      minWidth: 90,
                      flex: 1,
                      maxWidth: "100%",
                      "& .MuiSelect-select": { fontSize: 11 },
                      "& .MuiInputLabel-root": { fontSize: 11 },
                    }}
                  >
                    <InputLabel id="room-humidity-select-label">Sensor Device</InputLabel>
                    <Select
                      labelId="room-humidity-select-label"
                      value={selectedHumidityDevice}
                      label="Sensor Device"
                      onChange={handleHumidityDeviceChange}
                      sx={{ height: 26 }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root": { fontSize: 11, fontFamily: "inherit" },
                            "& .MuiList-root": { padding: 0.5 },
                          },
                        },
                      }}
                    >
                      <MenuItem value="Average" sx={{ fontSize: 11 }}>Average</MenuItem>
                      {activeRoomSensorDevices.map((device) => (
                        <MenuItem
                          key={device.deviceSerialNo}
                          value={device.deviceSerialNo}
                          sx={{ fontSize: 11 }}
                        >
                          {device.deviceName || device.deviceSerialNo}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Typography variant="h6" sx={{ mt: 0.5, fontWeight: 700 }}>
                  {roomHumidityValue === "NA" ? "NA" : `${roomHumidityValue} %`}
                </Typography>
              </Paper>
              <Paper
                elevation={2}
                sx={{
                  p: 1,
                  borderRadius: 0.75,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ flexWrap: "nowrap", rowGap: 0.5, minWidth: 0 }}
                >
                  <Typography variant="subtitle2" color="text.secondary" noWrap sx={{ flexShrink: 0 }}>
                    PPFD
                  </Typography>
                  <FormControl
                    size="small"
                    sx={{
                      minWidth: 90,
                      flex: 1,
                      maxWidth: "100%",
                      "& .MuiSelect-select": { fontSize: 11 },
                      "& .MuiInputLabel-root": { fontSize: 11 },
                    }}
                  >
                    <InputLabel id="ppfd-device-select-label">Sensor Device</InputLabel>
                    <Select
                      labelId="ppfd-device-select-label"
                      value={selectedSensorDevice}
                      label="Sensor Device"
                      onChange={handleSensorDeviceChange}
                      sx={{ height: 26 }}
                    >
                      <MenuItem value="Average" sx={{ fontSize: 11 }}>Average</MenuItem>
                      {activeRoomSensorDevices.map((device) => (
                        <MenuItem
                          key={device.deviceSerialNo}
                          value={device.deviceSerialNo}
                          sx={{ fontSize: 11 }}
                        >
                          {device.deviceName || device.deviceSerialNo}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Typography variant="h6" sx={{ mt: 0.5, fontWeight: 700 }}>
                  {ppfdValue === "NA" ? "NA" : `${ppfdValue} μmol/m2/s`}
                </Typography>
              </Paper>
              <Paper
                elevation={2}
                sx={{
                  p: 1,
                  borderRadius: 0.75,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ flexWrap: "nowrap", rowGap: 0.5, minWidth: 0 }}
                >
                  <Typography variant="subtitle2" color="text.secondary" noWrap sx={{ flexShrink: 0 }}>
                    DLI (Last Day)
                  </Typography>
                  <FormControl
                    size="small"
                    sx={{
                      minWidth: 90,
                      flex: 1,
                      maxWidth: "100%",
                      "& .MuiSelect-select": { fontSize: 11 },
                      "& .MuiInputLabel-root": { fontSize: 11 },
                    }}
                  >
                    <InputLabel id="dli-device-select-label">Sensor Device</InputLabel>
                    <Select
                      labelId="dli-device-select-label"
                      value={selectedSensorDevice}
                      label="Sensor Device"
                      onChange={handleSensorDeviceChange}
                      sx={{ height: 26 }}
                    >
                      <MenuItem value="Average" sx={{ fontSize: 11 }}>Average</MenuItem>
                      {activeRoomSensorDevices.map((device) => (
                        <MenuItem
                          key={device.deviceSerialNo}
                          value={device.deviceSerialNo}
                          sx={{ fontSize: 11 }}
                        >
                          {device.deviceName || device.deviceSerialNo}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Typography variant="h6" sx={{ mt: 0.5, fontWeight: 700 }}>
                  {dliLastDayValue === "NA" ? "NA" : `${dliLastDayValue} mol/m2/d`}
                </Typography>
              </Paper>
              <Paper
                elevation={2}
                sx={{
                  p: 1,
                  borderRadius: 0.75,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="subtitle2" color="text.secondary" noWrap sx={{ flexShrink: 0 }}>
                  Photoperiod
                </Typography>
                <Typography variant="h6" sx={{ mt: 0.5, fontWeight: 700 }}>
                  {photoperiodValue === "NA" ? "NA" : `${photoperiodValue} Hrs`}
                </Typography>
              </Paper>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 1,
                flex: 1,
                minHeight: 0,
                width: "100%",
                maxWidth: "100%",
                alignContent: "stretch",
              }}
            >
              <Paper elevation={2} sx={{ p: 1, borderRadius: 0.75, height: "100%", minHeight: 0, display: "flex", flexDirection: "column", width: "100%", minWidth: 0, boxSizing: "border-box" }}>
                <SpdGraph spectrum={spectrum} height={200} />
              </Paper>
              <Paper elevation={2} sx={{ p: 1, borderRadius: 0.75, height: "100%", minHeight: 0, display: "flex", flexDirection: "column", width: "100%", minWidth: 0, boxSizing: "border-box" }}>
                <RoutineScheduleChart
                  routines={routines}
                  spectrumById={routineSpectrums}
                  loading={routineChartLoading}
                  errorMsg={routineChartError}
                  colorMap={channelColorMap}
                  height={320}
                />
              </Paper>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
